<template src="./templates/sidebar-right.html"></template>
<script>
	export default {
		name: 'SidebarRight'
	};
</script>
